"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZFilter = exports.getODataFilter = exports.getODataSubFilter = void 0;
const kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
const kendo_react_data_tools_1 = require("@progress/kendo-react-data-tools");
const kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
const kendo_react_intl_1 = require("@progress/kendo-react-intl");
const kendo_react_ripple_1 = require("@progress/kendo-react-ripple");
const ZAutoComplete_1 = require("../ZAutoComplete/ZAutoComplete");
const ZComboBox_1 = require("../ZComboBox/ZComboBox");
const ZDatePicker_1 = require("../ZDatePicker/ZDatePicker");
const ZDateTimePicker_1 = require("../ZDateTimePicker/ZDateTimePicker");
const ll_1 = require("../../languages/ll");
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const styled_components_1 = __importDefault(require("styled-components"));
const isComplexFilter = (operator) => {
    return (operator != "isnull" &&
        operator != "isnotnull" &&
        operator != "isempty" &&
        operator != "isnotempty");
};
const dateFilterBuilder = (props, languageId, type) => {
    const { filter } = props, createDropDownItem = (key) => {
        return {
            text: ll_1.ll({ key: key, languageId }),
            key: key
        };
    }, dateRanges = [
        createDropDownItem("Today"),
        createDropDownItem("Yesterday"),
        createDropDownItem("ThisWeek"),
        createDropDownItem("ThisMonth"),
        createDropDownItem("ThisYear"),
        createDropDownItem("ThisQuarter"),
        createDropDownItem("LastWeek"),
        createDropDownItem("LastMonth"),
        createDropDownItem("LastYear"),
        createDropDownItem("LastQuarter"),
        createDropDownItem("LastRollingWeek"),
        createDropDownItem("LastRollingMonth"),
        createDropDownItem("LastRollingYear"),
        createDropDownItem("LastRollingQuarter")
    ];
    if (isNaN(Date.parse(filter.value))) {
        filter.value = null;
    }
    return filter.operator == `${type}-range` ? (react_1.default.createElement(kendo_react_dropdowns_1.DropDownList, { data: dateRanges, defaultItem: {
            text: ll_1.ll({ key: "ChooseDateRange", languageId }),
            key: "Default"
        }, textField: "text", dataItemKey: "key", onChange: event => {
            props.onFilterChange({
                nextFilter: {
                    field: filter.field,
                    operator: `${type}-range`,
                    value: event.value.key
                }
            });
        } })) : isComplexFilter(filter.operator) ? (type === "date" ? (react_1.default.createElement(ZDatePicker_1.ZDatePicker, { value: filter.value && new Date(filter.value), onChange: (event) => {
            let value = event.value;
            if (value) {
                value = moment_1.default
                    .utc(value)
                    .hours(0)
                    .minutes(0)
                    .seconds(0)
                    .milliseconds(0)
                    .toDate();
            }
            let nextFilter = {
                field: filter.field,
                operator: filter.operator,
                value: value && value.toISOString()
            };
            props.onFilterChange({ nextFilter });
        } })) : (react_1.default.createElement(ZDateTimePicker_1.ZDateTimePicker, { value: filter.value && new Date(filter.value), onChange: (event) => {
            let value = event.value;
            if (value) {
                value = moment_1.default(value)
                    .seconds(0)
                    .milliseconds(0)
                    .toDate();
            }
            let nextFilter = {
                field: filter.field,
                operator: filter.operator,
                value: value && value.toISOString()
            };
            props.onFilterChange({ nextFilter });
        } }))) : (react_1.default.createElement("div", null));
};
const TextFilter = (props) => {
    return isComplexFilter(props.filter.operator) ? (react_1.default.createElement(kendo_react_data_tools_1.TextFilter, Object.assign({}, props))) : (react_1.default.createElement("div", null));
};
const NumericFilter = (props) => {
    return isComplexFilter(props.filter.operator) ? (react_1.default.createElement(kendo_react_data_tools_1.NumericFilter, Object.assign({}, props))) : (react_1.default.createElement("div", null));
};
const DateFilter = (props) => {
    const { languageId } = react_1.default.useContext(ll_1.llContext);
    return dateFilterBuilder(props, languageId, "date");
};
const DateTimeFilter = (props) => {
    const { languageId } = react_1.default.useContext(ll_1.llContext);
    return dateFilterBuilder(props, languageId, "datetime");
};
const EntityFilter = (props) => {
    const { filter } = props;
    const { operator } = filter;
    if (!isComplexFilter(filter.operator)) {
        return react_1.default.createElement("div", null);
    }
    else if (operator == "eq" || operator == "neq") {
        let columns = props.displayFields &&
            props.displayFields.map((e) => ({
                field: e,
                width: 150
            }));
        if (filter.fields) {
            props.onFilterChange({
                nextFilter: {
                    field: filter.field,
                    operator: filter.operator,
                    value: null
                }
            });
        }
        return (react_1.default.createElement(ZAutoComplete_1.ZAutoComplete, { onChange: (event) => {
                props.onFilterChange({
                    nextFilter: {
                        field: filter.field,
                        operator: filter.operator,
                        value: event.value && event.value.Id
                    }
                });
            }, entity: props.entity, endpoint: props.endpoint, columns: columns, textField: props.textField, queryParams: props.queryParams }));
    }
    else {
        if (!filter.fields) {
            props.onFilterChange({
                nextFilter: {
                    field: filter.field,
                    operator: filter.operator,
                    value: null,
                    fields: props.filterFields
                }
            });
        }
        return (react_1.default.createElement(kendo_react_inputs_1.Input, { onChange: (event) => {
                props.onFilterChange({
                    nextFilter: {
                        field: filter.field,
                        operator: filter.operator,
                        value: event.value,
                        fields: props.filterFields
                    }
                });
            } }));
    }
};
const ListFilter = (props) => {
    const { filter, listData, textField } = props;
    return isComplexFilter(props.filter.operator) ? (react_1.default.createElement(ZComboBox_1.ZComboBox, { data: listData, textField: textField, dataItemKey: "Id", onChange: (event) => {
            props.onFilterChange({
                nextFilter: {
                    field: filter.field,
                    operator: filter.operator,
                    value: event.value && event.value.Id
                }
            });
        } })) : (react_1.default.createElement("div", null));
};
const thisDateFilter = (field, type, unitOfTime) => {
    let startTime = (type === "date" ? moment_1.default().utc() : moment_1.default())
        .startOf(unitOfTime)
        .toDate()
        .toISOString(), endTime = (type === "date" ? moment_1.default().utc() : moment_1.default())
        .add(1, `${unitOfTime}s`)
        .startOf(unitOfTime)
        .toDate()
        .toISOString();
    return `((${field} ge ${startTime}) and (${field} lt ${endTime}))`;
};
const lastDateFilter = (field, type, unitOfTime) => {
    let startTime = (type === "date" ? moment_1.default().utc() : moment_1.default())
        .subtract(1, `${unitOfTime}s`)
        .startOf(unitOfTime)
        .toDate()
        .toISOString(), endTime = (type === "date" ? moment_1.default().utc() : moment_1.default())
        .startOf(unitOfTime)
        .toDate()
        .toISOString();
    return `((${field} ge ${startTime}) and (${field} lt ${endTime}))`;
};
const lastRollingDateFilter = (field, type, unitOfTime) => {
    let startTime = (type === "date" ? moment_1.default().utc() : moment_1.default())
        .subtract(1, `${unitOfTime}s`)
        .toDate()
        .toISOString(), endTime = (type === "date" ? moment_1.default().utc() : moment_1.default())
        .toDate()
        .toISOString();
    return `((${field} ge ${startTime}) and (${field} lt ${endTime}))`;
};
const getRangeFilters = (field, type, value) => {
    switch (value) {
        case "Today":
            return thisDateFilter(`${field}`, type, "day");
        case "Yesterday":
            return lastDateFilter(`${field}`, type, "day");
        case "ThisWeek":
            return thisDateFilter(`${field}`, type, "week");
        case "ThisMonth":
            return thisDateFilter(`${field}`, type, "month");
        case "ThisYear":
            return thisDateFilter(`${field}`, type, "year");
        case "ThisQuarter":
            return thisDateFilter(`${field}`, type, "quarter");
        case "LastWeek":
            return lastDateFilter(`${field}`, type, "week");
        case "LastMonth":
            return lastDateFilter(`${field}`, type, "month");
        case "LastYear":
            return lastDateFilter(`${field}`, type, "year");
        case "LastQuarter":
            return lastDateFilter(`${field}`, type, "quarter");
        case "LastRollingWeek":
            return lastRollingDateFilter(`${field}`, type, "week");
        case "LastRollingMonth":
            return lastRollingDateFilter(`${field}`, type, "month");
        case "LastRollingYear":
            return lastRollingDateFilter(`${field}`, type, "year");
        case "LastRollingQuarter":
            return lastRollingDateFilter(`${field}`, type, "quarter");
        default:
            return "";
    }
};
exports.getODataSubFilter = (subFilter) => {
    const { field, operator, value, fields } = subFilter;
    switch (operator) {
        case "eq":
            return value
                ? `(${field} eq ${value == "null" ? "'null'" : value})`
                : "";
        case "neq":
            return value
                ? `(${field} ne ${value == "null" ? "'null'" : value})`
                : "";
        case "contains":
            return value ? `substringof('${value}',${field})` : "";
        case "doesnotcontain":
            return value ? `(not substringof('${value}',${field}))` : "";
        case "startswith":
            return value ? `startswith(${field}, '${value}')` : "";
        case "endswith":
            return value ? `endswith(${field}, '${value}')` : "";
        case "isnull":
            return `(${field} eq null)`;
        case "isnotnull":
            return `(${field} ne null)`;
        case "isempty":
            return `(${field} eq '')`;
        case "isnotempty":
            return `(${field} ne '')`;
        case "gte":
            return value ? `(${field} ge ${value})` : "";
        case "gt":
            return value ? `(${field} gt ${value})` : "";
        case "lte":
            return value ? `(${field} le ${value})` : "";
        case "lt":
            return value ? `(${field} lt ${value})` : "";
        case "istrue":
            return `(${field} eq true)`;
        case "isfalse":
            return `(${field} eq false)`;
        case "datetime-range":
            return getRangeFilters(field, "datetime", value);
        case "date-range":
            return getRangeFilters(field, "date", value);
        case "multi-contains":
            return value && fields && fields.length
                ? `(${fields
                    .map((field) => `substringof('${value}',${field})`)
                    .join(" or ")})`
                : "";
        case "multi-doesnotcontain":
            return value
                ? `(${(fields || [])
                    .map((field) => `(not substringof('${value}',${field}))`)
                    .join(" and ")})`
                : "";
        case "multi-startswith":
            return value
                ? `(${(fields || [])
                    .map((field) => `startswith(${field}, '${value}')`)
                    .join(" or ")})`
                : "";
        case "multi-endswith":
            return value
                ? `(${(fields || [])
                    .map((field) => `endswith(${field}, '${value}')`)
                    .join(" or ")})`
                : "";
        default:
            return "";
    }
};
exports.getODataFilter = (filter) => {
    const { logic, filters } = filter;
    if (filters.length == 1) {
        let subFilter = filter.filters[0];
        if (subFilter.logic) {
            return exports.getODataFilter(subFilter);
        }
        else {
            return exports.getODataSubFilter(subFilter);
        }
    }
    else {
        var subFilters = filters.map(subFilter => {
            if (subFilter.logic) {
                let newSubFilter = exports.getODataFilter(subFilter);
                return newSubFilter ? `(${newSubFilter})` : "";
            }
            else {
                return exports.getODataSubFilter(subFilter);
            }
        });
        return subFilters
            .filter((value) => {
            return value;
        })
            .join(` ${logic} `);
    }
};
const StyledFilter = styled_components_1.default(kendo_react_data_tools_1.Filter) `
   font-family: ${props => props.theme["font-family"]} !important;

   .k-datetimepicker,
   .k-datepicker,
   .z-component {
      padding: 0;
   }

   .k-filter-field:hover,
   .k-filter-operator:hover,
   .k-filter-value:hover {
      background: ${props => props.theme["input-background-hover-color"]};
   }

   *:not(.k-icon) {
      font-family: ${props => props.theme["font-family"]} !important;
   }
`;
exports.ZFilter = (props) => {
    const [state, setState] = react_1.default.useState({
        filter: {
            logic: "and",
            filters: props.defaultFilter || []
        },
        oDataFilter: "",
        defaultFilterInitialized: false
    }), { languageId } = react_1.default.useContext(ll_1.llContext), fields = react_1.default.useMemo(() => {
        const getFieldName = (field) => {
            const shouldLocalize = field.localize == undefined ? true : field.localize;
            return shouldLocalize
                ? ll_1.ll({ key: field.label || field.field, languageId })
                : field.label || field.field;
        }, getDateOperators = (type, field) => [
            {
                text: ll_1.ll({
                    key: "DateRange",
                    languageId
                }),
                operator: `${type}-range`
            },
            { text: "filter.eqOperator", operator: "eq" },
            { text: "filter.notEqOperator", operator: "neq" },
            { text: "filter.afterOrEqualOperator", operator: "gte" },
            { text: "filter.afterOperator", operator: "gt" },
            { text: "filter.beforeOperator", operator: "lt" },
            { text: "filter.beforeOrEqualOperator", operator: "lte" },
            ...(field.nullable === true
                ? [
                    {
                        text: "filter.isNullOperator",
                        operator: "isnull"
                    },
                    {
                        text: "filter.isNotNullOperator",
                        operator: "isnotnull"
                    }
                ]
                : [])
        ];
        return props.fields.map(field => {
            const addField = (field, filter, operators) => {
                return {
                    name: field.field,
                    label: getFieldName(field),
                    filter: filter,
                    operators: operators
                };
            };
            switch (field.type) {
                case "text":
                    return addField(field, TextFilter, [
                        { text: "filter.containsOperator", operator: "contains" },
                        {
                            text: "filter.notContainsOperator",
                            operator: "doesnotcontain"
                        },
                        { text: "filter.eqOperator", operator: "eq" },
                        { text: "filter.notEqOperator", operator: "neq" },
                        {
                            text: "filter.startsWithOperator",
                            operator: "startswith"
                        },
                        { text: "filter.endsWithOperator", operator: "endswith" },
                        ...(field.nullable === true
                            ? [
                                {
                                    text: "filter.isNullOperator",
                                    operator: "isnull"
                                },
                                {
                                    text: "filter.isNotNullOperator",
                                    operator: "isnotnull"
                                }
                            ]
                            : []),
                        { text: "filter.isEmptyOperator", operator: "isempty" },
                        {
                            text: "filter.isNotEmptyOperator",
                            operator: "isnotempty"
                        }
                    ]);
                case "numeric":
                    return addField(field, NumericFilter, [
                        { text: "filter.eqOperator", operator: "eq" },
                        { text: "filter.notEqOperator", operator: "neq" },
                        { text: "filter.gteOperator", operator: "gte" },
                        { text: "filter.gtOperator", operator: "gt" },
                        { text: "filter.lteOperator", operator: "lte" },
                        { text: "filter.ltOperator", operator: "lt" },
                        ...(field.nullable === true
                            ? [
                                {
                                    text: "filter.isNullOperator",
                                    operator: "isnull"
                                },
                                {
                                    text: "filter.isNotNullOperator",
                                    operator: "isnotnull"
                                }
                            ]
                            : [])
                    ]);
                case "boolean":
                    return addField(field, () => {
                        return react_1.default.createElement("div", null);
                    }, [
                        {
                            text: ll_1.ll({
                                key: "IsTrue",
                                languageId
                            }),
                            operator: "istrue"
                        },
                        {
                            text: ll_1.ll({
                                key: "IsFalse",
                                languageId
                            }),
                            operator: "isfalse"
                        }
                    ]);
                case "date":
                    return addField(field, DateFilter, getDateOperators("date", field));
                case "datetime":
                    return addField(field, DateTimeFilter, getDateOperators("datetime", field));
                case "entity":
                    return {
                        name: field.field,
                        label: ll_1.ll({
                            key: field.entity || "",
                            languageId
                        }),
                        filter: (props) => {
                            return react_1.default.createElement(EntityFilter, Object.assign({}, props, field));
                        },
                        operators: [
                            { text: "filter.eqOperator", operator: "eq" },
                            { text: "filter.notEqOperator", operator: "neq" },
                            {
                                text: "filter.containsOperator",
                                operator: "multi-contains"
                            },
                            {
                                text: "filter.notContainsOperator",
                                operator: "multi-doesnotcontain"
                            },
                            {
                                text: "filter.startsWithOperator",
                                operator: "multi-startswith"
                            },
                            {
                                text: "filter.endsWithOperator",
                                operator: "multi-endswith"
                            },
                            ...(field.nullable === true
                                ? [
                                    {
                                        text: "filter.isNullOperator",
                                        operator: "isnull"
                                    },
                                    {
                                        text: "filter.isNotNullOperator",
                                        operator: "isnotnull"
                                    }
                                ]
                                : [])
                        ]
                    };
                case "list":
                    return {
                        name: field.field,
                        label: getFieldName(field),
                        filter: (props) => {
                            return react_1.default.createElement(ListFilter, Object.assign({}, props, field));
                        },
                        operators: [
                            { text: "filter.eqOperator", operator: "eq" },
                            { text: "filter.notEqOperator", operator: "neq" },
                            ...(field.nullable === true
                                ? [
                                    {
                                        text: "filter.isNullOperator",
                                        operator: "isnull"
                                    },
                                    {
                                        text: "filter.isNotNullOperator",
                                        operator: "isnotnull"
                                    }
                                ]
                                : [])
                        ]
                    };
                case "null":
                    return {
                        name: field.field,
                        label: getFieldName(field),
                        filter: () => react_1.default.createElement("div", null),
                        operators: [
                            { text: "filter.isNullOperator", operator: "isnull" },
                            {
                                text: "filter.isNotNullOperator",
                                operator: "isnotnull"
                            }
                        ]
                    };
            }
        });
    }, [languageId, props.fields]);
    kendo_react_intl_1.loadMessages({
        filter: {
            andLogic: ll_1.ll({
                key: "FilterableAnd",
                languageId
            }),
            orLogic: ll_1.ll({
                key: "FilterableOr",
                languageId
            }),
            containsOperator: ll_1.ll({
                key: "FilterableContains",
                languageId
            }),
            notContainsOperator: ll_1.ll({
                key: "FilterableDoesnotcontain",
                languageId
            }),
            eqOperator: ll_1.ll({
                key: "FilterableEq",
                languageId
            }),
            notEqOperator: ll_1.ll({
                key: "FilterableNeq",
                languageId
            }),
            startsWithOperator: ll_1.ll({
                key: "FilterableStartswith",
                languageId
            }),
            endsWithOperator: ll_1.ll({
                key: "FilterableEndswith",
                languageId
            }),
            isNullOperator: ll_1.ll({
                key: "FilterableIsnull",
                languageId
            }),
            isNotNullOperator: ll_1.ll({
                key: "FilterableIsnotnull",
                languageId
            }),
            isEmptyOperator: ll_1.ll({
                key: "FilterableIsempty",
                languageId
            }),
            isNotEmptyOperator: ll_1.ll({
                key: "FilterableIsnotempty",
                languageId
            }),
            gteOperator: ll_1.ll({
                key: "FilterableGte",
                languageId
            }),
            gtOperator: ll_1.ll({
                key: "FilterableGt",
                languageId
            }),
            lteOperator: ll_1.ll({
                key: "FilterableLte",
                languageId
            }),
            ltOperator: ll_1.ll({
                key: "FilterableLt",
                languageId
            }),
            afterOrEqualOperator: ll_1.ll({
                key: "FilterableDateGte",
                languageId
            }),
            afterOperator: ll_1.ll({
                key: "FilterableDateGt",
                languageId
            }),
            beforeOperator: ll_1.ll({
                key: "FilterableDateLt",
                languageId
            }),
            beforeOrEqualOperator: ll_1.ll({
                key: "FilterableDateLte",
                languageId
            })
        }
    }, languageId);
    react_1.default.useEffect(() => {
        const { filter, defaultFilterInitialized } = state, { onChange } = props;
        if (!defaultFilterInitialized) {
            let newODataFilter = exports.getODataFilter(filter);
            onChange && onChange(newODataFilter);
            setState({
                filter: state.filter,
                oDataFilter: newODataFilter,
                defaultFilterInitialized: true
            });
        }
    }, [props, state]);
    return (react_1.default.createElement(kendo_react_intl_1.LocalizationProvider, { language: languageId },
        react_1.default.createElement(kendo_react_ripple_1.Ripple, null,
            react_1.default.createElement(StyledFilter, { value: state.filter, onChange: (event) => {
                    let newODataFilter = exports.getODataFilter(event.filter);
                    newODataFilter != state.oDataFilter &&
                        props.onChange &&
                        props.onChange(newODataFilter);
                    setState({
                        ...state,
                        filter: event.filter,
                        oDataFilter: newODataFilter
                    });
                }, fields: fields }))));
};
//# sourceMappingURL=ZFilter.js.map